import { Funcionario } from 'service/api'

import { CreateSlice } from './index'

export type EmployeeState = {
    employeeId: number
    employee: Funcionario | null
    setEmployeeId: (id: number) => void
    setEmployee: (employee: Funcionario) => void
    employees: Funcionario[]
}

export const createEmployeeSlice: CreateSlice<EmployeeState> = (set, get) => ({
    employeeId: -1,
    employee: null,
    employees: [],
    setEmployeeId: (id: number) => {
        set({
            employeeId: id,
            employee: get().employees.find(e => e.id === id),
        })
    },
    setEmployee: (employee: Funcionario) => {
        set({ employee, employeeId: employee.id })
    },
})
